import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget, isPending } from "../../store/actions/todoActions";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";
import { useDropzone } from 'react-dropzone';

import { toast } from "react-toastify";
import { ReactComponent as MemberStandarIcon } from "../../assets/membership/member.svg";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import {  formatTime, scrollToSection, useHandleClickLoading } from "../../components/Common/utils";
import { ReactComponent as CameraIcon } from "../../assets/icon/camera.svg";

function EditProfile() {

    const Api = process.env.REACT_APP_API;
    const isLogin = localStorage.getItem("isLogin");
    const isProfile = localStorage.getItem("isProfile");
    const isSetPIN = localStorage.getItem("isSetPIN");
    const parseLogin = JSON.parse(isLogin);
    const profileData = JSON.parse(isProfile);
    const [formProfile, setformProfile] = useState([
        { title: "Nama Lengkap", value: "", disabled: false },
        { title: "Email", value: "", disabled: true },
        { title: "Level", value: "", disabled: true },
        { title: "Nomor Whatsapp", value: "", disabled: true },
    ]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [formPassword, setformPassword] = useState([
        { name: "password", title: "Password Lama", value: "", type: "password", placeholder: "Masukan Password Lama" },
        { name: "password_baru", title: "Password Baru", value: "", type: "password", placeholder: "Masukan Password Baru" },
        { name: "ulangi_password_baru", title: "Konfirmasi Password", value: "", type: "password", placeholder: "Konfirmasi Password Baru" },
    ]);
    const [formPIN, setformPIN] = useState([
        { name: "otp", title: "OTP", value: "", type: "number", placeholder: "Masukan OTP" },
        { name: "pin_baru", title: "PIN Baru", value: "", type: "password", placeholder: "Masukan PIN Baru" },
        { name: "ulangi_pin_baru", title: "Konfirmasi PIN", value: "", type: "password", placeholder: "Masukan Konfirmasi PIN" },
    ]);
    const [isResendPIN, setIsResendPIN] = useState(false);


    const [remainingTime, setRemainingTime] = useState(0);
    const [intervalId, setIntervalId] = useState(null);

    const handleClickLoading = useHandleClickLoading();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isSetPIN === true) {
            scrollToSection('changepin')
        }
        dispatch(isIdTarget(undefined));
        setformProfile([
            { title: "Nama Lengkap", value: profileData?.nama, disabled: false },
            { title: "Email", value: profileData?.email, disabled: true },
            { title: "Level", value: profileData?.level, disabled: true },
            { title: "Nomor Whatsapp", value: profileData?.ponsel, disabled: true },
        ])
    }, [dispatch]);

    useEffect(() => {
        if (remainingTime === 0) {
            clearInterval(intervalId);
        }
    }, [remainingTime]);
    useEffect(() => {
        const timer = setInterval(() => {
            setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
        }, 1000);
        setIntervalId(timer);
        return () => {
            clearInterval(timer);
        };

    }, []);

    const changePassword = async () => {
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            formPassword.forEach((item) => {
                params.append(item.name, item.value);
            });

            const response = await ApiService({
                baseurl: "user/ubah_profile?password",
                method: "POST",
                XGORDON: "UBAHPROFILE",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const changePIN = async () => {
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            formPIN.forEach((item) => {
                params.append(item.name, item.value);
            });

            const response = await ApiService({
                baseurl: "user/ubah_profile?setpin",
                method: "POST",
                XGORDON: "UBAHPROFILE",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                localStorage.setItem('isSetPIN', (false));
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleSendOTP = async (api) => {
        dispatch(isPending(true));
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);

            const response = await ApiService({
                baseurl: "user/ubah_profile",
                parameter: api,
                method: "POST",
                XGORDON: "UBAHPROFILE",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,
            });
            dispatch(isPending(false));
            setIsResendPIN(true)
            setRemainingTime(300)
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const changeEditProfile = async () => {
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            params.append('nama', formProfile[0]?.value);

            const response = await ApiService({
                baseurl: "user/ubah_profile?ubahnama",
                method: "POST",
                XGORDON: "UBAHPROFILE",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const setUploadPhoto = async () => {
        try {
            const formData = new FormData();
            formData.append('gambar', selectedFile, selectedFile.name);
            const headers = {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + parseLogin?.token,
                },
                body: formData,
            };
            const response = await fetch(Api + 'user/upload_profile?key=' + parseLogin?.apiKey, headers);
            const data = await response.json();
            if (response.status === 200) {
                toast.success(data.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.error(data.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.log('Error:', error);
        }
    }
    const handleInputChange = (index, value) => {
        const newInputs = [...formPassword];
        newInputs[index].value = value;
        setformPassword(newInputs);
    };
    const handleInputChangePIN = (index, value) => {
        const newInputs = [...formPIN];
        newInputs[index].value = value;
        setformPIN(newInputs);
    };


    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setSelectedFile(acceptedFiles[0]);
        }
    };
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: 'image/*',
        multiple: false,
    });
    return (
        <div className="flex flex-col gap-3 flex-1">
            <div className="flex flex-col p-3 gap-3 rounded-lg  shadow-inner  bg-cardLight dark:bg-cardDark relative">
               <div className="flex flex-row gap-3 items-center  sm:pt-1">
                    <div {...getRootProps()} className='relative aspect-square rounded-lg cursor-pointer '>
                        <LazyLoadImage
                            src={selectedFile ? URL.createObjectURL(selectedFile) : profileData?.profil}
                            alt={selectedFile ? selectedFile.path : profileData?.nama}
                            className=" object-cover  sm:h-32 h-20 aspect-square rounded-full"
                            effect="blur"
                        />
                        <div className="aspect-square absolute bottom-0 right-0 ">
                            <div className="rounded-full p-2 flex bg-[#1561C0]">
                                <CameraIcon fill="#ffffff" />
                            </div>
                        </div>
                        <input {...getInputProps()} style={{ display: 'none' }} />
                    </div>
                    <div className="flex flex-col flex-1">
                        <span
                            className={` sm:text-xl text-base font-bold `}
                        >
                            {profileData?.nama}
                        </span>
                        <span className={` sm:text-md text-sm mb-2`}>
                            {profileData?.email}
                        </span>
                        <Button
                            initialValue="Upload Foto Profile"
                            type="fill"
                            className="bg-gradient-to-r w-40 from-[#22BDE2] to-[#FC00FF] text-darkColor"
                            onClick={() => {
                                selectedFile ? setUploadPhoto() :
                                    toast.error('Gambar Belum Masuk', {
                                        position: toast.POSITION.TOP_RIGHT,
                                    })
                            }}
                        />
                    </div>
                    <div className="sm:flex hidden flex-col ">
                            {profileData?.level === "member" &&
                                <MemberStandarIcon className="w-20 h-20" />
                            }
                            {profileData?.level === "silver" &&
                                // <MemberSilverIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/SIVLER.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                            {profileData?.level === "gold" &&
                                // <MembergoldIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/GOLD.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                            {profileData?.level === "pro" &&
                                // <MemberProIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/PRO.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                        </div>
                </div>
                <div
                    className={`grid grid-cols-1 ${formProfile.length === 1 ? "sm:grid-cols-1" : "sm:grid-cols-2"
                        } gap-3`}
                >
                    <ConditionalRender
                        productsData={formProfile}
                        isLoading={false}
                        model={"emptyData"}
                    >
                        {formProfile.map((input, index) => (
                            <Input
                                key={index}
                                id={input.title}
                                label={input.title}
                                name={input.title}
                                value={input.value === undefined ? "" : input.value}
                                onChange={(value) => {
                                    const inputValue = value;
                                    if (inputValue.length <= 200) {
                                        setformProfile((prevFormProfile) => {
                                            const updatedFormProfile = [...prevFormProfile];
                                            const namaLengkapIndex = updatedFormProfile.findIndex((item) => item.title === "Nama Lengkap");
                                            if (namaLengkapIndex !== -1) {
                                                updatedFormProfile[namaLengkapIndex].value = inputValue;
                                            }
                                            return updatedFormProfile;
                                        });
                                    }
                                }}
                                
                                disabled={input.disabled}
                                type={input.type}
                                options={input.options}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`${input.placeholder}`}
                            />
                        ))}
                    </ConditionalRender>
                </div>
                <Button
                    initialValue="Simpan Perubahan"
                    type="fill"
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"
                    onClick={() => { changeEditProfile() }}
                />

            </div>
            <div className="flex flex-col rounded-lg shadow-inner relative  bg-cardLight dark:bg-cardDark">
                <div className="flex flex-col gap-1 p-3">
                    <span className=" text-lg font-medium line-clamp-1">
                        Security Password
                    </span>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-2 px-3 pb-3 ">
                    <ConditionalRender
                        productsData={formPassword}
                        isLoading={false}
                        model={"emptyData"}
                    >
                        {formPassword.map((input, index) => (
                            <Input
                                key={index}
                                id={input.title}
                                label={input.title}
                                name={input.name}
                                value={input.value === undefined ? "" : input.value}
                                onChange={(value) => {
                                    const inputValue = value;
                                    if (inputValue.length <= 200) {
                                        handleInputChange(index, inputValue);
                                    }
                                }}
                                type={input.type}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`${input.placeholder}`}
                            />
                        ))}
                    </ConditionalRender>
                </div>
                <div className="flex items-end p-3 pt-0 ">
                    <Button
                        initialValue="Simpan Perubahan"
                        type="fill"
                        className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"
                        onClick={() => {
                            changePassword()
                        }}
                    />
                </div>
            </div>
            <div className="flex flex-col rounded-lg shadow-inner relative  bg-cardLight dark:bg-cardDark" id="changepin">
                <div className="flex flex-col gap-1 p-3">
                    <span className=" text-lg font-medium line-clamp-1">
                        PIN Security
                    </span>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-2 px-3 pb-3 ">
                    <ConditionalRender
                        productsData={formPIN}
                        isLoading={false}
                        model={"emptyData"}
                    >
                        {formPIN.map((input, index) => (
                            <Input
                                key={index}
                                id={input.title}
                                label={input.title}
                                name={input.name}
                                value={input.value === undefined ? "" : input.value}
                                onChange={(value) => {
                                    const inputValue = value;
                                    if (inputValue.length <= 200) {
                                        handleInputChangePIN(index, inputValue);
                                    }
                                }}
                                type={input.type}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`${input.placeholder}`}
                            />
                        ))}
                    </ConditionalRender>
                </div>
                <div className="flex items-center gap-2 p-3 pt-0">
                    <div className="flex pb-1 ">
                        {remainingTime === 0 ?
                            <Button
                                initialValue={isResendPIN ? "Kirim Ulang OTP" : "Kirim OTP"}
                                type="fill"
                                className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"
                                onClick={() => {
                                    handleSendOTP(isResendPIN ? 'resendotp' : 'sendotp');
                                }}
                            />
                            :
                            <span className={` text-sm `}>
                                Kirim ulang kode unik dalam <b>{formatTime(remainingTime)}</b> detik
                            </span>
                        }
                    </div>
                    <div className="flex pb-1 items-end ">
                        <Button
                            initialValue="Simpan Perubahan"
                            type="fill"
                            className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"
                            onClick={() => {
                                changePIN()
                            }}
                        />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default EditProfile;
